// src/App.js
import React, { useState, useEffect } from 'react';
import { Route, Switch, NavLink } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import cx from "classnames";

import BESC from './views/BESC';
import Referrals from './views/Referrals';
import Trading from './views/Trading';
import Markets from './views/Markets';

import './App.css';

import moneyLogo from './img/logo_MONEY.svg';

import { FaSun, FaMoon, FaTimes } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { RiMenuLine } from 'react-icons/ri';

function AppHeaderLinks({ mode, small, clickCloseIcon }) {
  return (
    <div className="App-header-links">
      {small &&
        <div className="App-header-links-header">
          <div className="App-header-menu-icon-block" onClick={() => clickCloseIcon()}>
            <FiX className="App-header-menu-icon" />
          </div>
          <NavLink exact activeClassName="active" className="App-header-link-main" to="/">
            <img src={moneyLogo} alt="MoneyX Logo" />
          </NavLink>
        </div>
      }
      <div className="App-header-link-container">
        <NavLink to="/" className="nav-link">BESC</NavLink>
        <NavLink to="/markets" className="nav-link">Markets</NavLink>
        <NavLink to="/referrals/besc" className="nav-link">Referrals</NavLink>
        <NavLink to="/trading" className="nav-link">Trading</NavLink>
      </div>
    </div>
  );
}

const App = () => {
  const [mode, setMode] = useState(null);
  const [isDrawerVisible, setIsDrawerVisible] = useState(undefined);

  const slideVariants = {
    hidden: { x: "-100%" },
    visible: { x: 0 }
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  useEffect(() => {
    const savedMode = window.localStorage.getItem('mode');
    const targetMode = savedMode === 'light' ? 'light' : 'dark';
    document.querySelector('body').style.backgroundColor =
      targetMode === 'dark' ? '#0A0B11' : '#f6f9ff';
    setMode(targetMode);
  }, []);

  const switchMode = () => {
    const targetMode = mode === 'dark' ? 'light' : 'dark';
    window.localStorage.setItem('mode', targetMode);
    document.querySelector('body').style.backgroundColor =
      targetMode === 'dark' ? '#0A0B11' : '#f6f9ff';
    setMode(targetMode);
  };

  if (!mode) return null;

  return (
    <div className={cx("App", mode)}>
      {isDrawerVisible &&
        <AnimatePresence>
          <motion.div
            className="App-header-backdrop"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={fadeVariants}
            transition={{ duration: 0.2 }}
            onClick={() => setIsDrawerVisible(!isDrawerVisible)}
          />
        </AnimatePresence>
      }

      <div className="nav">
        <div className="nav-left">
          <div className="App-header-menu-icon-block"
               onClick={() => setIsDrawerVisible(!isDrawerVisible)}>
            {!isDrawerVisible && <RiMenuLine className="App-header-menu-icon" />}
            {isDrawerVisible && <FaTimes className="App-header-menu-icon" />}
          </div>

          <a href="https://moneyxpro.com" target="_blank" className="nav-logo" rel="noreferrer">
            <img width="36" src={moneyLogo} alt="MoneyX" />
            <span className="nav-brand-text">MoneyX</span>
          </a>

          <NavLink exact to="/" className="nav-link" activeClassName="active">BESC</NavLink>
          <NavLink to="/markets" className="nav-link" activeClassName="active">Markets</NavLink>
          <NavLink to="/referrals/besc" className="nav-link" activeClassName="active">Referrals</NavLink>
          <NavLink to="/trading" className="nav-link" activeClassName="active">Trading</NavLink>
        </div>

        <div className="nav-right">
          <a href="https://moneyxpro.com" target="_blank" className="nav-link" rel="noreferrer">APP</a>
          <a href="https://moneyxpro.com/docs#/docs" target="_blank" className="nav-link" rel="noreferrer">DOCS</a>
          <div className="modeselect" onClick={() => switchMode()}>
            {mode === 'dark' ? <FaSun /> : <FaMoon />}
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isDrawerVisible &&
          <motion.div
            onClick={() => setIsDrawerVisible(false)}
            className="App-header-links-container App-header-drawer"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={slideVariants}
            transition={{ duration: 0.2 }}
          >
            <AppHeaderLinks mode={mode} small clickCloseIcon={() => setIsDrawerVisible(false)} />
          </motion.div>
        }
      </AnimatePresence>

      <div className="content">
        <Switch>
          <Route exact path="/" render={(props) => <BESC {...props} mode={mode} />} />
          <Route exact path="/markets" render={(props) => <Markets {...props} mode={mode} />} />
          <Route exact path="/referrals/:chainName" render={(props) => <Referrals {...props} mode={mode} />} />
          <Route exact path="/trading" component={Trading} />
        </Switch>
      </div>
    </div>
  );
};

export default App;
